import React, { Component } from 'react'

class PasswordResetSubmitted extends Component {
  render() {

    return (
      <div className="container auth">
        <div className="dialog login" style={{textAlign: 'center'}}>
          <h3>Password Reset Requested</h3>
          <p>You should receive an email from no-reply@showcaseidx.com with instructions resetting your password.</p>
          <a href="/login">Click here to return to the Login Page</a>
        </div>
      </div>
    )
  }
}

export default PasswordResetSubmitted



// WEBPACK FOOTER //
// client/components/auth/PasswordResetSubmitted.js